import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const WHATSAPP_URL = "https://wa.me/5511989666465?text=Ol%C3%A1%2C+quero+conhecer+os+servi%C3%A7os+da+Triad.";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      data-testid="site-nav"
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-ink-950/80 backdrop-blur-xl border-b border-white/[0.06]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-3 flex items-center justify-between gap-8">
        <a href="/" data-testid="brand-logo" className="flex items-center group shrink-0">
          <img
            src="/triad-logo.png"
            alt="Triad Marketing"
            className="h-20 md:h-24 w-auto object-contain transition-all duration-500 group-hover:scale-105"
            style={{
              filter: "drop-shadow(0 0 18px rgba(107, 138, 255, 0.35)) drop-shadow(0 0 40px rgba(10, 77, 255, 0.15))",
            }}
          />
        </a>

        <div className="hidden md:flex items-center gap-10 text-xs uppercase tracking-[0.25em] text-white/60">
          <a href="/#servicos" className="hover:text-blue transition-colors" data-testid="nav-servicos">Serviços</a>
          <a href="/social-media" className="hover:text-blue transition-colors" data-testid="nav-social">Social Media</a>
          <a href="/#contato" className="hover:text-blue transition-colors" data-testid="nav-contato">Contato</a>
        </div>

        <a
          data-testid="nav-whatsapp"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noreferrer"
          className="group relative inline-flex items-center gap-2 rounded-full border border-blue/50 px-5 py-2.5 text-[11px] uppercase tracking-[0.28em] text-white hover:bg-blue hover:text-ink-950 transition-all duration-500"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-blue group-hover:bg-ink-950 transition-colors" />
          Fale agora
        </a>
      </div>
    </motion.nav>
  );
}
